export const DisabledIconFocus = {
  bind(el) {
    el.querySelectorAll('.v-input__icon button').forEach(x =>
      x.setAttribute('tabindex', -1)
    );
  }
};
